import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import LinePanelAddIcon from 'LuxKit/Icons/line/LinePanelAddIcon'
import LinePlaneFlyIcon from 'LuxKit/Icons/line/LinePlaneFlyIcon'
import LineReturnFlightAltIcon from 'LuxKit/Icons/line/LineReturnFlightAltIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import React from 'react'
import { useIntl } from 'react-intl'

function FlightDealUSPs() {
  const intl = useIntl()

  return <CardCarousel pageSize={3} width="75vw">
    <VerticalSpacer gap={12}>
      <LinePanelAddIcon size="L" />
      <VerticalSpacer gap={4}>
        <BodyText variant="medium" weight="bold">
          {intl.formatMessage({
            id: 'aE3ct3HjxF',
            defaultMessage: 'Bundle hotels + flights',
            description: 'USP title for bundling hotels and flights on flight deal page',
          })}
        </BodyText>
        <BodyText variant="medium" colour="neutral-two">
          {intl.formatMessage({
            id: '4udoDrH5U0',
            defaultMessage: 'Easily plan and book your next trip when you bundle hotels + flights',
            description: 'USP description for bundling hotels and flights on flight deal page',
          })}
        </BodyText>
      </VerticalSpacer>
    </VerticalSpacer>
    <VerticalSpacer gap={12}>
      <LinePlaneFlyIcon size="L" />
      <VerticalSpacer gap={4}>
        <BodyText variant="medium" weight="bold">
          {intl.formatMessage({
            id: 'PK+cpHT+zF',
            defaultMessage: 'Your choice of airline',
            description: 'USP title for airline choice on flight deal page',
          })}
        </BodyText>
        <BodyText variant="medium" colour="neutral-two">
          {intl.formatMessage({
            id: 'qoUMstbkT1',
            defaultMessage: 'Choose from more than 500 global airlines and fly with your favourite',
            description: 'USP description for airline choice on flight deal page',
          })}
        </BodyText>
      </VerticalSpacer>
    </VerticalSpacer>
    <VerticalSpacer gap={12}>
      <LineReturnFlightAltIcon size="L" />
      <VerticalSpacer gap={4}>
        <BodyText variant="medium" weight="bold">
          {intl.formatMessage({
            id: '2AYbulEcNm',
            defaultMessage: 'Flexible flight options',
            description: 'USP title for flexible flight options on flight deal page',
          })}
        </BodyText>
        <BodyText variant="medium" colour="neutral-two">
          {intl.formatMessage({
            id: 'YHzlbyWapx',
            defaultMessage: 'Find one-way or return flights, across all cabin classes, and choose the best for you',
            description: 'USP description for flexible flight options on flight deal page',
          })}
        </BodyText>
      </VerticalSpacer>
    </VerticalSpacer>
  </CardCarousel>
}

export default FlightDealUSPs
